module.exports = __webpack_public_path__ + "static/media/crow_pick_roti.2ae7b1df.gif";